/**
 * collaborator.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Group } from "./group";
import { User } from "./user";

export class Collaborator extends User
{
  public constructor (
    public name : string,
    public userId : number[],
    public org : string
  )
  {
    super(name, org);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/identity/collaborator.ts